module.exports = __webpack_public_path__ + "images/shop/favicon-kfz24/mstile-150x150.png";